import type { StatusValue } from "@shared/types";
import { cn } from "@/lib/utils";

interface StatusStyle {
  label: string;
  classes: string;
}

const STYLE_BY_STATUS: Record<string, StatusStyle> = {
  "0": { label: "Down", classes: "bg-status-down/15 text-status-down border-status-down/30" },
  "1": { label: "Up", classes: "bg-status-up/15 text-status-up border-status-up/30" },
  "2": { label: "Pending", classes: "bg-status-pending/15 text-status-pending border-status-pending/30" },
  "3": {
    label: "Maintenance",
    classes: "bg-status-maintenance/15 text-status-maintenance border-status-maintenance/30",
  },
};

const PAUSED: StatusStyle = { label: "Paused", classes: "bg-status-paused/15 text-status-paused border-status-paused/30" };
const UNKNOWN: StatusStyle = { label: "Unknown", classes: "bg-muted text-muted-foreground border-border" };

export function StatusBadge({
  status,
  paused = false,
  className,
}: {
  status: StatusValue | null;
  paused?: boolean;
  className?: string;
}) {
  const style = paused ? PAUSED : (status != null && STYLE_BY_STATUS[String(status)]) || UNKNOWN;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        style.classes,
        className,
      )}
    >
      {style.label}
    </span>
  );
}
